jQuery( function($) {

    var windowWidth     = $(window).width(),
        windowHeight    = $(window).height(),
        fullView        = ( windowWidth >= 768 ? true : false );

    /**
     * Setup heightEQ to load on specified elements
     */
    // $('.heightEQ').heightEQ();

    /**
     * Setup FancyBox
     */
    $('.fb, .fancybox, .fb-video, .fancybox-video, .wp-block-button.block-fb > a, .wp-gallery > a').fancybox({
        caption : function( instance, item ) {

            console.log( 'Title: ' + $(this).attr('title') );
            return $(this).data('caption') || $(this).attr('title');
        },
        buttons: [ 'zoom', 'slideShow', 'fullScreen', 'thumbs', 'close' ]
    });

    /**
     * Initialize tabs
     */
    $('.tabs').tabs();

    /**
     * Automatically redirect page when blog category is selected
     */
    $('#blog-term-select').on( 'input', function() {
        var termURL = $(this).val();
        window.location.href = termURL;
    });

    /**
     * Changing Pager Next & Previous Text into Arrows
     */
    $('.pager > li a.next').empty().append( '<i class="fas fa-chevron-right icon" aria-hidden="true"></i>' );
    $('.pager > li a.prev').empty().append( '<i class="fas fa-chevron-left icon" aria-hidden="true"></i>' );

    /**
     * Alt search form functionality
     */
    if ( $('.search-form-alt').length ) {

        var searchInput = $('.search-form-alt input[type="text"]');

        if ( windowWidth > 1176 ) {

            $('.search-form-alt').children('input').click( function() {
                $(this).addClass('active');

                searchInput.focus();
            });

        } else {
            searchInput.addClass('active');
            searchInput.attr('placeholder', 'Search');
        }
    }

    if ( $('.click-to-copy').length ) {
        const clickEl = $('.click-to-copy');

        clickEl.click( function(e) {
            e.preventDefault();
            navigator.clipboard.writeText( window.location.href );

            $('.copy-text').animate({
                opacity: 1,
                bottom: '30px'
            }, 100, function() {

                setTimeout( function() {
                    $('.copy-text').css({ 'opacity' : 0, 'bottom' : 0 });
                }, 1000);
            });
        });
    }

    if ( windowWidth <= 1176 ) {

        if ( $('table').length ) {

            $('table').each( function() {
                $(this).wrap('<div class="scrollbar-outer"></div>');
            });

            $('.scrollbar-outer').scrollbar();
        }

        // if ( $('.term-wrapper.tab-label-row').length !== 0 ) {
        //     const termWrapper = $('.term-wrapper.tab-label-row');

        //     termWrapper.each( function(e) {
        //         const termAccWrapper    = '<div class="accordions"><div class="accordion"><div class="content"><ul class="inner-acc-terms"></ul></div></div></accordions>';
        //         const termAccTitle      = '<h6 class="title acc-title"><span>All</span><span class="activation"><i class="fas fa-plus"></i><i class="fas fa-minus"></i></span></h6>'
        //         $(this).children().wrapAll( termAccWrapper );
        //         $(this).find('.accordion').prepend( termAccTitle );

        //         $(this).find('.accordions').jQoordion({
        //             initialShowIndex    : -1,
        //             allowMultiple       : false
        //         });
        //     });
        // }
    }

    if ( windowWidth > 900 ) {
        $('.locations-row').slick({
            arrows          : true,
            dots            : false,
            slidesToShow    : 4,
            infinite        : true,
            slidesToScroll  : 1,
        });

    } else {

        $('.locations-row').slick({
            arrows          : true,
            dots            : false,
            slidesToShow    : 1,
            slidesToScroll  : 1,
            infinite        : false,
            rows            : 4,
            slidesPerRow    : 1,
            adaptiveHeight  : true
        });
    }
});

jQuery( function($) {

    let form = $('form#member-login-form');

    //Clear form after submit, security
    form.on( 'submit', function() {
        setTimeout( function() {
            form.trigger('reset');
        }, 1500, form );
    });
});

jQuery( function($) {

    if ( $('.page-section.height-eq').length !== 0 ) {
        const heightEqualGrid = $('.page-section.height-eq');

        heightEqualGrid.each( function(e) {
            const gridEl = $(this).find('.grid-element, .link-outer');
            const gridElHeights = [];

            gridEl.each( function(e) {
                gridElHeights.push( $(this).height() );
            });

            const tallestHeight = Math.ceil( Math.max(...gridElHeights) );

            gridEl.css({'min-height' : tallestHeight + 'px'});
        });
    }

});

jQuery( function($) {

    $(document).on( 'click', 'a', function(e) {

        let $showAlert          = true;
        const noAlertClass      = 'no-alert';
        const $link             = $(this).attr('href');
        const $alert_string     = "You are now leaving NuMark Credit Union's website and linking to a website maintained by a third party. NuMark Credit Union does not provide, and is not responsible for, the products, services and content offered through third-party websites. The National Credit Union Administration or any other agency may not insure the products and services of third-party websites. In addition, our privacy policy does not apply to third-party websites. This third-party website may have privacy policies which differ from our privacy policy and may provide less security than our website. You should consult the privacy policies on any of the third-party websites for further information.";
        const $searchString     = '(' + window.location.hostname + ')|(tel:)|(email:)|(mailto:)|(numarkcuonline.org)|(numarkcu.mymortgage-online.com)|(youtube.com)|(linkedin.com)|(twitter.com)|(facebook.com)|(javascript)|#';
        const $matches          = $link.match( $searchString );

        if (
            ! $link ||
            $link == '#' ||
            $matches ||
            $(this).hasClass( noAlertClass ) ||
            $(this).parent().hasClass( noAlertClass ) ||
            $(this).find('> *:first-child').hasClass( noAlertClass ) ||
            ! $(this).parent().hasClass('share-inner')
        ) {
            $showAlert = false;
        }

        console.log( 'Link: ' + $link );

        if ( 
            $showAlert && confirm( $alert_string ) !== true ||
            $link != '#' && $(this).parent().hasClass('share-inner') && confirm( $alert_string ) !== true
        ) {
            e.preventDefault();
            return false;
        }
    });
});

jQuery( function($) {

    const hdrNotification = $('#hdr-notification');
    const todaysDate = new Date();
    const expireThreeDays = new Date( todaysDate.setDate( todaysDate.getDate() + 3 ) );

    if ( hdrNotification ) {
        const exitBtn = hdrNotification.find('.notification-exit');

        exitBtn.click( function(e) {
            e.preventDefault();
            document.cookie = `hide_notification=true; expires=${expireThreeDays}; path=/; SameSite=None; Secure`;
            hdrNotification.hide();
        });
    }
});

jQuery( function($) {

    if ( $('.section-testimonials.has-slider').length !== 0 ) {
        const testimonialSlider = $('.section-testimonials.has-slider .testimonials');

        testimonialSlider.each( function(e) {

            if ( $(window).width() > 900 ) {

                $(this).slick({
                    arrows          : true,
                    dots            : false,
                    slidesToShow    : 4,
                    infinite        : true,
                    slidesToScroll  : 1,
                });

            } else {

                $(this).slick({
                    arrows          : true,
                    dots            : false,
                    slidesToShow    : 1,
                    infinite        : true,
                    slidesToScroll  : 1,
                    rows            : 2,
                    slidesPerRow    : 1,
                    adaptiveHeight  : true,
                });
            }

        });
    }
});

jQuery(window).on( 'load', function() {

    jQuery('.wp-gallery.masonry').masonry({
        itemSelector: 'a'
    });

    if ( jQuery(window).width() > 768 ) {

        jQuery('.section-testimonials:not(.has-slider) .testimonials').masonry({
            itemSelector: '.testimonial'
        });
    }
});

jQuery( function($) {

    $('.faqs').addClass('expandable').jQoordion({
        accordionSelector   : '.faq',
        titleSelector       : '.faq-title',
        contentSelector     : '.faq-content',
        initialShowIndex    : 0,
        allowMultiple       : false
    });

    $('.tab-accordions').jQoordion({
        initialShowIndex    : 0,
        allowMultiple       : false
    });

    $('.content-accordions').jQoordion({
        initialShowIndex    : 0,
        allowMultiple       : false
    });

});

jQuery( function($) {

    const popupCtr = $('.popmake');

    if ( popupCtr.length !== 0 ) {

        popupCtr.each( function(e) {
            const popupContent = $(this).find( '> .popmake-content' );
            const popupExit = $(this).find( '> .popmake-close' );
            const popupOverlayExit = $(this).parent();
            const popupIframe = popupContent.find( 'iframe' );

            if ( popupIframe.length !== 0 ){

                //Prevent videos in iframe from continuing to play on exit in popup maker
                popupExit.click( function(e) {
                    popupIframe.attr('src', popupIframe.attr('src'));
                });

                if ( popupOverlayExit.hasClass('pum-click-to-close') ) {

                    popupOverlayExit.click( function(e) {
                        popupIframe.attr('src', popupIframe.attr('src'));
                    });
                }
            }
        });
    }

});

jQuery( function($) {

    $('#hdr').stickify({
        minHeight   : 480,
        css         : {
            'z-index' : 9999,
        }
    });

    var mainMenu            = $('#main-menu');
    var navExpandSel        = '#nav-expand';
    var activeClass         = 'mobile-nav-menu-active';
    const hdrTop            = $('.hdr-top');

    if ( mainMenu.length ) {
        const mainMenuWrapper = $('#hdr .menu-wrapper');
        const mobileMenuWrapper = $('<div class="mobile-menu-wrapper"><div class="mobile-main"></div></div>');
        const mobileMenuInner = $('<div class="mobile-menu-inner"></div>');

        mainMenuWrapper.append('<a href="#" id="nav-expand"><span class="line"></span><span class="line"></span><span class="line"></span></a>');

        $('#main-menu li.has-sub-menu ul.sub-menu li ul.sub-menu').parent().addClass('has-sub-menu');

        $('#main-menu li.has-sub-menu ul.sub-menu li.has-sub-menu ul.sub-menu').siblings('a').wrap('<div class="menu-acc"></div>');
        $('.menu-acc').append( '<span class="acc-action"></span>' );

        const mainMenuTopItems  = $('#main-menu > li.has-sub-menu');
        const mainMenuSubItems  = $('#main-menu > li.has-sub-menu ul.sub-menu li.has-sub-menu');

        if ( $(window).width() > 1176 ) {
        if ( mainMenuTopItems ) {

            mainMenuTopItems.each( function(e) {
                const menuItemWrap = $(this);

                $(this).find('> a').click( function(e) {
                    //Prevent link from working unless on mobile
                    e.preventDefault();

                    mainMenuTopItems.not(menuItemWrap).removeClass('active');
                    mainMenuSubItems.removeClass('active');

                    $(this).parent().toggleClass('active');
                });
            });
        }
        }

        if ( mainMenuSubItems ) {

            mainMenuSubItems.each( function(e) {
                const menuItemSubWrap = $(this);

                $(this).find('> .menu-acc .acc-action').click( function(e) {
                    $(this).parent().parent().siblings('li.has-sub-menu.active').removeClass('active')
                        .find('li.has-sub-menu.active').removeClass('active');

                    //mainMenuSubItems.not(menuItemSubWrap).removeClass('active');
                    $(this).parent().parent().toggleClass('active');
                });
            });
        }

        if ( $(window).width() <= 1176 ) {
            mainMenu.find('> li.has-sub-menu:not(".nav-btn") > ul.sub-menu').siblings('a').wrap('<div class="menu-acc top-acc"></div>');
            $('.top-acc').append( '<span class="acc-action"></span>' );

            mainMenu.find('> li:not(".nav-btn")').wrapAll(mobileMenuInner);
            mainMenu.wrap( mobileMenuWrapper );

            if ( mainMenuTopItems ) {

                mainMenuTopItems.each( function(e) {
                    const menuItemWrap = $(this);

                    $(this).find('> .menu-acc .acc-action').click( function(e) {
                        mainMenuTopItems.not(menuItemWrap).removeClass('active');
                        mainMenuSubItems.removeClass('active');

                        $(this).parent().parent().toggleClass('active');
                    });
                });
            }

            //Lift items designated single out of columns they originally appear in to circumvent accordion
            const singleMenuItems = mainMenu.find('li.single-item');
            const singleMenuItemParent = singleMenuItems.parent().parent().parent();

            singleMenuItems.appendTo( singleMenuItemParent );

            if ( hdrTop ) {
                hdrTop.insertAfter( $('.mobile-main') );
            }

            $('.mobile-menu-wrapper').wrapInner('<div class="overflow-wrapper"></div>');

            //Handle translation flag - scroll container down when clicked open
            const overflowWrapper = $('.mobile-menu-wrapper .overflow-wrapper');
            const gtranslateMenu = $('.gtranslate_wrapper');
            const gtranslateMenuSelect = gtranslateMenu.find('.gt-selected');

            gtranslateMenuSelect.click( function(e) {

                overflowWrapper.animate({
                    scrollTop: $(document).height() - overflowWrapper.height()
                }, 600);
            });
        }

        $('body').on( 'click', navExpandSel, function(e) {
            e.preventDefault();
            $('html').toggleClass(activeClass);
            return false;
        });

        /**
         * Check if potential page anchor and close menu
         */
        mainMenu.find('a').click( function(e) {

            var href = $(this).attr('href');

            if ( $('html').hasClass(activeClass) && href.indexOf('#') !== -1 ) {
                $('html').removeClass(activeClass);
            }
        });
    }
});

jQuery( function($) {

    if ( typeof jQuery.fn.scrollTo !== 'undefined' ) {

        $('a[href*="#"]:not([href="#"])').click( function(e) {
            var headerHeight = $('#hdr.is-sticky').height() || 0;
            jQuery.fn.scrollTo( $(this).attr('href'), headerHeight, 300 );
        });
    }
});

jQuery(window).on( 'load', function() {
    //jQuery.fn.scrollTo( '#blog-topbar', headerHeight, 400 );

    const headerHeight = jQuery('#hdr.is-sticky').height() || 0;
    const searchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(searchParams.entries());

    if ( params.datatab ) {
        const target = jQuery(`a[data-tab=${params.datatab}]`);
        const targetId = `label-${params.datatab}`;

        if ( target ) {

            //Add id to anchor
            target.attr('id', targetId);

            //Click the target (open the tab)
            target.click();

            //Scroll to the target
            jQuery.fn.scrollTo( `#${targetId}`, 200, 350 );
        }
    }

    if ( window.location.hash ) {
        jQuery.fn.scrollTo( window.location.hash, headerHeight, 0 );
    }
});

jQuery( function($) {

    /**
     * Toggles skip nav active state
     */
    if ( $('#skip-nav').length ) {

        var skipNav     = $('#skip-nav'),
            skipExit    = $('#skip-nav #skip-exit'),
            skipWrap    = skipNav.children(),
            skipLast    = skipNav.find('li').last().children();

        skipNav.focusin( function() {
            $(this).addClass('active');
        });

        /* Remove active state when exiting focus on last anchor */
        skipLast.focusout( function() {
            skipNav.removeClass('active');
        });

        /* Remove active state when destination is selected */
        skipWrap.children().each( function() {
            var skipChild = $(this).children();

            skipChild.click( function() {

                if ( ! skipChild.hasClass('home') ) {
                    skipNav.removeClass('active');
                }
            });
        });

        skipExit.click( function(e) {
            e.preventDefault();
            skipNav.removeClass('active');
        });

        /* Remove active state when clicking outside of navigation */
        $(document).click( function(e) {

            if ( skipNav.hasClass('active') ) {

                if ( $(e.target).closest(skipNav).length === 0 ) {
                    skipNav.removeClass('active');
                }
            }
        });
    }
});

jQuery(window).on( 'load', function() {

    const $ = jQuery;

    if ( window.location.hash ) {

        const hash  = window.location.hash;
        const $elem = $('a[href="' + hash + '"]');
        const $tabs = $elem.closest('.tabs');

        if ( $tabs.length ) {

            let hdrHeight = ( $('#hdr').height() || 0 );

            jQuery('html,body').animate({
                scrollTop: $tabs.offset().top - hdrHeight
            }, 400 );
        }
    }
});

/**
 * Check if page is being viewed on a mobile device according to wp_is_mobile()
 */
function is_mobile() {
    return ( jQuery('body').hasClass( 'is_mobile' ) ? true : false );
}